import type { PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody } from '@fukuri-admins/apis/client/gen/model';
import { TopBannerDropdownMenu } from '../..';

type TopBannerDropdownMenuProps = React.ComponentProps<typeof TopBannerDropdownMenu>;

type GenerateToggleStatusRequestArgs = {
  /** 更新対象のトップバナーデータ */
  topBanner: TopBannerDropdownMenuProps['topBanner'];
  /** 現在のアクティブ状態 */
  currentIsActive: boolean;
};

type IGenerateToggleStatusRequest = (
  args: GenerateToggleStatusRequestArgs
) => PutApiV1ThreeLetterCodePartnerAdminsTopBannersIdBody;

/**
 * ステータス切り替え用のAPIリクエストボディを生成する
 *
 * @param topBanner - 更新対象のトップバナーデータ
 * @param currentIsActive - 現在のアクティブ状態（true: 表示中, false: 非表示）
 * @returns PUTリクエストボディ（statusを反転した状態）
 */
export const generateToggleStatusRequest: IGenerateToggleStatusRequest = ({
  topBanner,
  currentIsActive,
}) => ({
  top_banner: {
    title: topBanner.title,
    transition_url: topBanner.transitionUrl,
    status: currentIsActive ? 1 : 0, // 0: active(表示), 1: inactive(非表示)
    sort_order: topBanner.sortOrder,
    image: undefined, // 既存画像を維持
  },
});
